import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { addIcons } from 'ionicons';
import { calendarOutline, locationOutline, settings, heartOutline } from 'ionicons/icons';

// nel costruttore o in ngOnInit
addIcons({ calendarOutline, locationOutline, settings, heartOutline });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
